export default __webpack_public_path__ + "static/media/34-TimidKereru.174ce10b.jpeg";